<template>
  <div class="pa-6" data-testid="prompts">
    <div class="d-flex flex-column gap-6">
      <PageHeader
          title="Prompts"
          :loading="loading"
          @refresh="refreshData()"
      />
      <v-card
        :loading="loading"
        :disabled="loading"
        loader-height="2"
        data-testid="prompts__panel"
        class="pa-2 d-flex flex-column gap-2"
      >
        <v-card-text class="pa-0" data-testid="prompts__header">
          <div class="d-flex align-center">
            <div class="search-input-width">
              <lb-string
                data-testid="prompts__search-input"
                label="Search"
                outlined
                hidedetails
                v-model="searchList"
              ></lb-string>
            </div>
          </div>
        </v-card-text>
        <lb-datatablenew
          :headers="promptHeader"
          :items="filteredFeaturesData"
          :enableslot="['index', 'status', 'type', 'actions']"
          :perpage="10"
        >
          <template v-slot:item.index="{ item, index, page, perpage }">
            <span data-testid="prompts__index">{{ (page - 1) * perpage + index + 1 }}</span>
          </template>
          <template v-slot:item.status="{ item }">
             <StatusIndicator
              :variant="item.status ? 'active' : 'inactive'"
              :custom-label="item.status ? 'Active' : 'Inactive'"
              class=""
              size="sm"
              outlined
              style="width: auto;"
              cornerRadius="8px"
            />
          </template>
           <template v-slot:item.type="{ item }">
             <div class="d-flex flex-wrap gap-2" data-testid="prompts__type-container">
              <v-chip
                v-for="(prompt, i) in item.prompts"
                :key="i"
                class="mailChip text-capitalize"
                data-testid="prompts__type-chip"
              >
                {{ prompt.type }}
              </v-chip>
             </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn icon small @click="editItem(item)" data-testid="prompts__edit-btn">
              <img src="/img/icons/PenEditIcon.svg" alt="">
            </v-btn>
          </template>
        </lb-datatablenew>

        <v-dialog v-model="promptDialog" width="60vw" persistent data-testid="prompts__dialog">
          <v-card>
            <v-card-text class="tableHeaderBg d-flex align-center py-2 px-4" data-testid="prompts__dialog-header">
              <span class="" data-testid="prompts__dialog-title">Update Prompt</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="promptDialog = false" class="ml-2" data-testid="prompts__dialog-close-btn"
                ><v-icon data-testid="prompts__dialog-close-icon">mdi-close</v-icon></v-btn
              >
            </v-card-text>
            <v-card-text class="mt-4 pt-4" data-testid="prompts__dialog-form">
              <v-row>
                <v-col cols="6" class="my-0 py-1">
                  <lb-string label="Type" v-model="promptObject.type" disabled data-testid="prompts__dialog-type-field"/>
                </v-col>
                <v-col cols="6" class="my-0 py-1">
                  <lb-string label="Name" v-model="promptObject.name" disabled data-testid="prompts__dialog-name-field"/>
                </v-col>
                <v-col cols="12" class="my-0 py-1">
                  <lb-textarea label="Content" v-model="promptObject.content" data-testid="prompts__dialog-content-field"/>
                </v-col>
                <v-col cols="12" class="my-0 py-1">
                 <v-switch  v-model="promptObject.status"
                    inset color="success" class="ma-0" :false-value="false" :true-value="true" hide-details label="Status"  
                    />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text class="d-flex">
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="promptUpdate()" data-testid="prompts__dialog-update-btn"><p>Update</p></v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
         <v-dialog v-model="promptfeatureDialog"  width="60vw" persistent data-testid="prompts__dialog">
          <v-card>
            <v-card-text class="tableHeaderBg d-flex align-center py-2 px-4" data-testid="prompts__dialog-header">
              <span class="" data-testid="prompts__dialog-title">Feature Prompt</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="promptfeatureDialog = false" class="ml-2" data-testid="prompts__dialog-close-btn"
                ><v-icon data-testid="prompts__dialog-close-icon">mdi-close</v-icon></v-btn
              >
            </v-card-text>
            <v-card-text class="mt-4 pt-4" data-testid="prompts__dialog-form">
              <v-row>
                <v-col cols="6" class="my-0 py-1">
                  <lb-dropdown label="Type*" v-model="featureData.type" data-testid="prompts__dialog-type-field" :items="featureItems" :error="featureErrors.type"/>
                </v-col>
                <v-col cols="6" class="my-0 py-1">
                  <lb-string label="Feature*" v-model="featureData.feature" data-testid="prompts__dialog-type-field" :error="featureErrors.feature"/>
                </v-col>
                  <v-col cols="6" class="my-0 py-1">
                  <lb-string label="Name" v-model="featureData.name" data-testid="prompts__dialog-type-field"/>
                </v-col>
                 <v-col cols="6" class="my-0 py-1">
                  <v-switch  v-model="featureData.status"
                    inset color="success" class="ma-0" :false-value="false" :true-value="true" hide-details label="Status"  
                    />
                </v-col>
                <v-col cols="12" class="my-0 py-1">
                  <lb-textarea label="Content*" v-model="featureData.content" data-testid="prompts__dialog-content-field" :error="featureErrors.content"/>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text class="d-flex">
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="featureUpdate(featureData)" data-testid="prompts__dialog-update-btn"><p>Update</p></v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import { MESSAGES } from '@/modules/admin/utils/constants.js';
import PageHeader from '@/modules/varianceanalysis/components/PageHeader.vue';
import StatusIndicator from '@/modules/varianceanalysis/components/StatusIndicator.vue';

export default {
    name: 'Prompts',
    components: {
        PageHeader,
        StatusIndicator
    },
  data() {
    return {
      headers: [
      { text: '', value: 'data-table-expand' },
      { text: 'Feature Name', value: 'name', sortable: true },
      { text: 'Feature', value: 'feature', sortable: true },
      { text: 'Prompt Count', value: 'promptCount', sortable: true },
      { text: 'Actions', value: 'actions', sortable: false },
      ],
      promptHeader: [
      {text: 'S.No', value: 'index'},
      {text: 'Feature Name', value: 'name'},
      {text: 'Description', value: 'feature'},
      {text: 'Status', value: 'status'},
      {text: 'Prompt Variants', value: 'type'},
      {text: 'Actions', value: 'actions', sortable: false},
      ],
      promptDialog: false,
      promptObject: {},
      searchList: '',
      featureData:{},
      promptfeatureDialog:false,
      featureItems:['instruction','output'],
      featureErrors:{},
    };
  },
  computed: {
    featuresData() {
      return this.$store.getters['admin/getPrompts'];
    },
    loading() {
      return this.$store.getters['admin/getPromptsLoading'];
    },
    filteredFeaturesData() {
      if (!this.searchList) return this.featuresData;
      const search = this.searchList.toLowerCase();
      return this.featuresData.filter(item =>
        (item.feature && item.feature.toLowerCase().includes(search)) ||
        (item.prompts && item.prompts.some(p =>
          (p.type && p.type.toLowerCase().includes(search)) ||
          (p.content && p.content.toLowerCase().includes(search))
        ))
      );
    }
  },
    created() {
        this.refreshData();
    },
    methods: {
        async refreshData() {
            try {
                await this.$store.dispatch('admin/fetchPrompts', this.axios);
            } catch (error) {
                this.$store.commit('sbError', error.message || error || MESSAGES.ERROR.UNKNOWN_ERROR);
                console.log(error);
            }
        },
         editPrompt(item,prompt) {
            this.promptDialog = true;
            this.promptObject = { ...prompt };
        },
        async promptUpdate(){
            try {
                await this.$store.dispatch('admin/updatePromptById', {
                    axiosInstance: this.axios,
                    promptData: this.promptObject
                });
                
                this.promptDialog = false;
                this.promptObject = {};
                this.$store.commit('sbSuccess', MESSAGES.SUCCESS.PROMPT_UPDATED);
                this.refreshData();
                
            } catch (error) {
                this.errors = {};
                if (error.response?.data?.data && error.response.data.data.length > 0 && error.response.data.data[0].index0) {
                    this.errors = error.response.data.data[0].index0;
                }
                this.$store.commit('sbError', error.message || error || MESSAGES.ERROR.UNKNOWN_ERROR);
                console.log(error);
            }
        },
        editItem(item) {
          this.$nova.gotoLink({ path: `/admin/prompts/details/${item.feature}` });
        },
        async featureUpdate(item){
          // Clear previous errors
          this.featureErrors = {};
          
          // Validation
          let hasErrors = false;
          
          if (!item.content || item.content.trim() === '') {
            this.featureErrors.content = [MESSAGES.ERROR.CONTENT_REQUIRED];
            hasErrors = true;
          }
          
          if (!item.feature || item.feature.trim() === '') {
            this.featureErrors.feature = [MESSAGES.ERROR.FEATURE_REQUIRED];
            hasErrors = true;
          }
          
          if (!item.type || item.type === '') {
            this.featureErrors.type = [MESSAGES.ERROR.TYPE_REQUIRED];
            hasErrors = true;
          }
          
          // If validation fails, return early
          if (hasErrors) {
            this.$store.commit('sbError', MESSAGES.ERROR.FILL_REQUIRED_FIELDS);
            return;
          }
          
          // If validation passes, make the API call via Vuex
          try {
              await this.$store.dispatch('admin/createFeaturePrompt', {
                  axiosInstance: this.axios,
                  featureData: item
              });
              
              this.promptfeatureDialog = false;
              this.featureData = {};
              this.featureErrors = {};
              this.$store.commit('sbSuccess', MESSAGES.SUCCESS.FEATURE_PROMPT_CREATED);
              this.refreshData();
              
          } catch (error) {
              this.featureErrors = {};
              if (error.response?.data?.data && error.response.data.data.length > 0 && error.response.data.data[0].index0) {
                  this.featureErrors = error.response.data.data[0].index0;
              }
              this.$store.commit('sbError', error.message || error || MESSAGES.ERROR.UNKNOWN_ERROR);
              console.log(error);
          }
        },

    }
};
</script>

<style scoped>
.prompt-card {
    height: 400px;
    overflow: auto;
}
.prompt-table ::v-deep tr.v-data-table__expanded__content {
    box-shadow: none !important;
}
</style>
<style scoped>
.search-input-width {
  max-width: 250px;
  min-width: 180px;
  width: 100%;
}
</style>